<template>

    <div>

          
       
        <section id="form-view">
            <div id="form-wrapper" class="container ">

                <DynamicForm :form="form"/>

            </div>
        </section> 

    </div>

</template>

<script>

    
    
    import DynamicForm from './DynamicForm'

    export default {
     
       name: 'FormView',

       props: {            
              form: {
                  type: Object,
                  required: true
              }
          },


       components: { DynamicForm }



        
    }
</script>

<style scoped>





   
</style>


// WEBPACK FOOTER //
// src/FormView.vue